import { backdropClasses } from "@mui/material/Backdrop";
import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiBackdrop = {
	styleOverrides: {
		root: {
			[`&:not(.${backdropClasses.invisible})`]: {
				backgroundColor: "rgba(0, 0, 0, 0.5)",
				backdropFilter: "none",
			},
		},
	},
} satisfies Components<Theme>["MuiBackdrop"];
